<mat-progress-bar
  mode="indeterminate"
  color="warn"
  *ngIf="progressBar.active$ | async"
></mat-progress-bar>
